// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file supervisor/v1/environmentopts.proto (package supervisor.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetGitDiffRequest, GetGitDiffResponse, GetGitStatusRequest, GetGitStatusResponse } from "./environmentopts_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service supervisor.v1.EnvironmentOpsService
 */
export const EnvironmentOpsService = {
  typeName: "supervisor.v1.EnvironmentOpsService",
  methods: {
    /**
     * @generated from rpc supervisor.v1.EnvironmentOpsService.GetGitStatus
     */
    getGitStatus: {
      name: "GetGitStatus",
      I: GetGitStatusRequest,
      O: GetGitStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc supervisor.v1.EnvironmentOpsService.GetGitDiff
     */
    getGitDiff: {
      name: "GetGitDiff",
      I: GetGitDiffRequest,
      O: GetGitDiffResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

